import { inject } from "@angular/core";
import {
  CanActivateFn,
  CanMatch,
  Route,
  UrlSegment,
  UrlTree,
} from "@angular/router";

import { MsalService } from "@azure/msal-angular";
import { AuthService } from "./auth.service";
import { commonEnv } from "src/environments/environment.common";

export const authGuardFn: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const msalService = inject(MsalService);

  const targetUrl = state.url;
  const userInfo = authService.getUserInfo();

  if (userInfo) {
    if (
      userInfo.tfp === commonEnv.agentSignInPolicy &&
      Object.entries(route.queryParams).length === 0
    )
      authService.setUserType("AGENT");
    else {
      authService.setUserType("APPLICANT");
    }

    return true;
  } else {
    if (targetUrl === `/${commonEnv.azureAgentCallbackUrl}`) {
      authService.setUserType("AGENT");
    } else {
      authService.setUserType("APPLICANT");
    }
  }

  // Check if the user is authenticated by calling the service's method
  const isAuthenticated = await authService.isAuthenticated();

  if (!isAuthenticated) {
    msalService.instance.setActiveAccount(null); // Reset the active account if not authenticated
    authService.login();

    return false;
    // return await firstValueFrom(msalGuard.canActivate(route, state));
  }

  return true;
};

export const canMatchGuardFn = async (route: Route, segments: UrlSegment[]) => {
  const authService = inject(AuthService);
  const isAuthenticated = await authService.isAuthenticated();
  return isAuthenticated;
};
